<div class="signature-method-options">
  <div *ngFor="let method of options"
       class="signature-method-option"
       [class.signature-method-option--disabled]="isDisabled(method)">
    <label class="checkbox mb-0 compact" [for]="'signature-method-' + method">
      <input [type]="multiple ? 'checkbox' : 'radio'"
             name="signatureMethod"
             test-id="signatureMethodToggle"
             [id]="'signature-method-' + method"
             [checked]="isSelected(method)"
             [disabled]="isDisabled(method)"
             (change)="select(method)">
      {{ 'DOCUMENTS.signature_method_' + method | translate }}
    </label>
  </div>
</div>
